<template>
  <button
    class="custom-quiz-tile-container"
    @click="tileClicked"
  >
    <icon
      class="create-icon"
      name="cross"
      variant="7b7b7b"
    />
    Create Quiz
    <div
      v-if="locked"
      class="lock"
    >
      <icon
        class="lock-icon"
        name="lock"
        :variant="'white'"
      />
    </div>
  </button>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['customQuizTileClicked'],
  methods: {
    tileClicked() {
      this.$emit('customQuizTileClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-quiz-tile-container {
  align-items: center;
  background: white;
  border: 2px dashed #7b7b7b;
  box-sizing: border-box;
  color: #7b7b7b;
  display: inline-flex;
  flex-direction: column;
  font-size: rem-calc(12);
  font-weight: $semi-bold;
  height: rem-calc(100);
  justify-content: center;
  margin: rem-calc(10) rem-calc(4) rem-calc(10) 0;
  padding: rem-calc(10);
  position: relative;
  text-align: center;
  width: rem-calc(120);

  .create-icon {
    width: rem-calc(36);
    height: rem-calc(36);
    transform: rotate(45deg);
  }

  .lock {
    align-items: center;
    background-color: #000;
    border-radius: 24px;
    box-sizing: border-box;
    display: flex;
    height: 24px;
    justify-content: center;
    padding: 6px;
    position: absolute;
    top: -12px;
    right: -12px;
    width: 24px;
  }
}
</style>
